<template>
  <section id="sectors" class="py-24 bg-slate-50 border-t border-slate-100">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
        <div class="max-w-2xl">
          <h2 class="text-amber-500 font-bold uppercase tracking-wider text-sm mb-2">Industries We Serve</h2>
          <h3 class="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4">Building excellence across diverse markets</h3>
          <p class="text-lg text-slate-600">From dynamic commercial spaces to specialized hospitality environments, our expertise spans the full spectrum of modern development.</p>
        </div>
        <div class="hidden md:block">
          <button class="text-amber-600 font-bold hover:text-amber-500 transition-colors inline-flex items-center gap-2 group">
            View All Projects 
            <svg class="w-5 h-5 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
          </button>
        </div>
      </div>

      <div v-if="loading" class="text-center py-12">
        <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-amber-500"></div>
        <p class="mt-4 text-slate-500 font-medium">Loading projects...</p>
      </div>

      <div v-else class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <div v-for="(project, index) in projects" :key="project.id" 
             @click="goToProject(project.id)"
             :class="{'sm:col-span-2 lg:col-span-1': index === 3, 'lg:col-span-2': index === 4}"
             class="group relative h-80 rounded-2xl overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-all duration-300">
          <div class="absolute inset-0 bg-slate-900/60 group-hover:bg-slate-900/40 transition-colors z-10"></div>
          <div class="absolute inset-0 bg-gradient-to-t from-slate-900 to-transparent opacity-90 z-10"></div>
          <div class="absolute inset-0 bg-slate-800 transform group-hover:scale-105 transition-transform duration-700">
            <img v-if="project.cover_image_path" :src="getImageUrl(project.cover_image_path)" :alt="project.title" class="w-full h-full object-cover" />
          </div>
          
          <div class="absolute inset-0 p-6 flex flex-col justify-end z-20">
            <h4 class="text-2xl font-bold text-white mb-2 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">{{ project.title }}</h4>
            <div class="h-0 opacity-0 group-hover:h-auto group-hover:opacity-100 transition-all duration-300">
              <p class="text-gray-300 text-sm mt-2">{{ project.category }}</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="mt-8 md:hidden text-center">
        <button class="text-amber-600 font-bold hover:text-amber-500 transition-colors inline-flex items-center gap-2">
          View All Projects
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import projectService from '@/services/projectService';

export default {
  name: 'SectorsSection',
  data() {
    return {
      projects: [],
      loading: true
    }
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL.replace('/api', '') : 'https://em-admin.test';
    }
  },
  async created() {
    try {
      const response = await projectService.getProjects();
      // Show up to 5 featured active projects
      this.projects = response.data.filter(p => p.is_active).slice(0, 5); 
    } catch (error) {
      console.error('Error fetching projects:', error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    getImageUrl(path) {
      if (!path) return '';
      if (path.startsWith('http')) return path;
      return `${this.apiUrl}/${path}`;
    },
    goToProject(id) {
      if(this.$route.path !== `/projects/${id}`) {
         this.$router.push(`/projects/${id}`).catch(() => {});
      }
    }
  }
}
</script>
